import { useEffect, useRef, useState } from "react";

export const formatClock = (seconds) => {
  const cs = Math.max(0, Math.floor((Number(seconds) || 0) * 100 + 1e-6));
  const mins = Math.floor(cs / 6000);
  const secs = Math.floor((cs % 6000) / 100);
  const hundredths = cs % 100;
  return `${mins}:${String(secs).padStart(2, "0")}.${String(hundredths).padStart(2, "0")}`;
};

// Runs a smooth local countdown from `time` while `running`; resyncs whenever `time` changes.
export const useCountdown = (time, running) => {
  const [value, setValue] = useState(time);
  const anchorRef = useRef({ base: time, at: Date.now() });

  useEffect(() => {
    anchorRef.current = { base: time, at: Date.now() };
    setValue(time);
  }, [time]);

  useEffect(() => {
    if (!running) return undefined;
    anchorRef.current = { base: anchorRef.current.base, at: Date.now() };
    const id = setInterval(() => {
      const { base, at } = anchorRef.current;
      setValue(Math.max(0, base - (Date.now() - at) / 1000));
    }, 50);
    return () => {
      clearInterval(id);
      const { base, at } = anchorRef.current;
      const frozen = Math.max(0, base - (Date.now() - at) / 1000);
      anchorRef.current = { base: frozen, at: Date.now() };
      setValue(frozen);
    };
  }, [running]);

  return value;
};

export const GameClock = ({ time, running = false, className = "", testId }) => {
  const value = useCountdown(time, running);
  const low = value < 30;
  return (
    <div
      data-testid={testId}
      className={`timer px-3 py-1.5 sm:px-4 sm:py-2 rounded-md text-xl sm:text-2xl font-bold font-mono tabular-nums text-center min-w-[7.5rem] sm:min-w-[8.5rem]
        ${running ? "timer-active" : "bg-muted"} ${low ? "timer-low" : ""} ${className}`}
    >
      {formatClock(value)}
    </div>
  );
};

export default GameClock;
